<template>
  <div class="m-activity-select">
    <div class="type-box">
      <div class="type-item" v-for="item in activityType" :key="item.route">
        <div class="img-box">
          <img :src="item.imgUrl" alt="">
        </div>
        <div class="footer">
          <div class="icon"></div>
          <div class="name">{{ item.name }}</div>
          <el-button type="primary" class="mr10" @click="onAdd(item.route)" >创建</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img_dzp from '@/assets/market_images/img_dzp.png'
import img_ggl from '@/assets/market_images/img_ggl.png'
import img_lqzx from '@/assets/market_images/img_lqzx.png'
import img_sq from '@/assets/market_images/img_sq.png'
import img_hdbm from '@/assets/market_images/img_hdbm.png'
import img_ms from '@/assets/market_images/img_ms.png'
import img_fqhd from '@/assets/market_images/img_fqhd.png'
export default {
  name: "marketActivityListSelect",
  data() {
    return {
      activityType: [
        {
          name: '大转盘',
          imgUrl: img_dzp,
          route: '/market/activityList/add?type=Roulette'
        },
        {
          name: '刮刮乐',
          imgUrl: img_ggl,
          route: '/market/activityList/add?type=Lottery'
        },
        {
          name: '领券中心',
          imgUrl: img_lqzx,
          route: '/market/activityList/addCouponCenter?type=CouponCenter'
        },
        {
          name: '售券',
          imgUrl: img_sq,
          route: '/market/activityList/addCouponSell?type=SaleCoupon'
        },
        {
          name: '活动报名',
          type: 'SignUp',
          imgUrl: img_hdbm,
          route: '/market/activityList/addActivityApply?type=SignUp'
        },
        {
          name: '秒杀',
          type: 'FlashSaleCoupon',
          imgUrl: img_ms,
          route: '/market/ActivityList/addSeckill?type=FlashSaleCoupon'
        },
        {
          name: '发券活动',
          type: 'CouponDistribution',
          imgUrl: img_fqhd,
          route: '/market/activityList/addSendCoupon?type=CouponDistribution'
        },
      ]
    };
  },
  created() {},
  methods: {
    // 点击创建按钮
    onAdd(route) {
      this.$router.push(route);
    }
  },
};
</script>

<style lang="scss" scoped>
.m-activity-select {
  padding: 39px 20px;
  box-sizing: border-box;

  .type-box {
    display: flex;
    flex-wrap: wrap;

    .type-item {
      width: 320px;
      border: 1px solid #ccc;
      border-radius: 4px;
      overflow: hidden;
      margin-right: 50px;
      margin-bottom: 50px;

      .img-box {
        height: 184px;
        padding: 11px 0;
        background-color: #F2F3F5;
        text-align: center;

        img {
          height: 100%;
        }
      }

      .footer {
        padding: 17px 20px;
        background-color: #fff;
        display: flex;

        .name {
          flex: 1;
          height: 32px;
          line-height: 32px;
          font-size: 16px;
          color: #333;
        }

        .el-button {
          min-width: 80px;
          height: 32px;
          line-height: 32px;
        }

        .icon {
          width: 32px;
          position: relative;

          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            content: '';
            width: 16px;
            height: 16px;
            border-radius: 8px;
            background: #05C8AF;
          }
          &::after {
            position: absolute;
            top: 50%;
            left: 11px;
            transform: translateY(-50%);
            content: '';
            width: 16px;
            height: 16px;
            border-radius: 8px;
            opacity: 0.8;
            background: #3775FF;
          }
        }
      }
    }
  }
}
</style>
